import React from "react";
import { useCallback } from "react";
import styles from "./ReservationCell.module.css";
import PropTypes from "prop-types";

const ReservationCell = ({ cell, onClick}) => {
    const { color } = cell;

    let backgroundColor = "transparent";
    let cursor = "pointer";
    let isClickable = true;

    const now = new Date();
    const isPast = cell.time < now;

    let handleClick = onClick;

    if (color === "green" || color === "red" || (color === "none" && isPast)) {
        backgroundColor = color === "green" ? "rgba(0, 255, 0, 0.9)" : color === "red" ? "rgba(255, 50, 10, 0.8)" : backgroundColor;
        if (color !== "green" || isPast) {
            isClickable = false;
            cursor = "default";
        }
    } else if (color === "yellow") {
        backgroundColor = "rgba(60, 130, 240, 0.8)";
    }

    const handleCellClick = useCallback(() => {
        if (isClickable) {
            handleClick();
        }
    }, [isClickable, handleClick]);

    const cellStyle = {
        backgroundColor: backgroundColor,
        cursor: cursor,
    };

    return (
        <div className={styles.cell} style={cellStyle} onClick={handleCellClick} />
    );
};

ReservationCell.propTypes = {
    cell: PropTypes.shape({
        court: PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
        }).isRequired,
        time: PropTypes.instanceOf(Date).isRequired,
        color: PropTypes.string.isRequired,
        selected: PropTypes.bool.isRequired,
    }).isRequired,
    onClick: PropTypes.func.isRequired,
};

export default ReservationCell;
